import {useCallback, useState} from 'react';

import type {StopResizeParams} from '@pb/kit-component-data-table-v2';

const INIT_STATE = {};

export const useDataTableColumnsWidthOnResize = () => {
    const [columnsWidth, setColumnsWidth] = useState<{[key: string]: number}>(INIT_STATE);

    const onStopResize = useCallback(({columnId, width, minWidth, maxWidth}: StopResizeParams) => {
        let value = width;
        if (minWidth && width < minWidth) {
            value = minWidth;
        }

        if (maxWidth && width > maxWidth) {
            value = maxWidth;
        }
        setColumnsWidth({
            ...columnsWidth,
            [columnId]: value,
        });
    }, [columnsWidth]);

    const getColumnWidthByColumnId = useCallback((columnId: string) => {
        return columnsWidth[columnId];
    }, [columnsWidth]);

    return {
        onStopResize,
        getColumnWidthByColumnId,
    };
};
